import moment from "moment";
import { CN_MONTH_MAPPER } from "./components/popSelector/cnCharacter";

export default {
  methods: {
    getPreDate(value, interval, num = 1) {
      return moment(value)
        .subtract(num, `${interval}s`)
        .toDate()
        .getTime();
    },
    getNextDate(value, interval, num = 1) {
      return moment(value)
        .add(num, `${interval}s`)
        .toDate()
        .getTime();
    },
    isNotNumber(number) {
      const NEGATIVE_INTEGER_EXPRESS = /^-[1-9]\d*$/;
      const POSITIVE_INTEGER_EXPRESS = /^\+?[1-9]\d*$/;
      const DECIMAL_EXPRESS = /^[-+]?\d+\.\d*$|^[-+]?\d*\.\d+$/;
      return (
        number === undefined ||
        !(
          NEGATIVE_INTEGER_EXPRESS.test(number) ||
          POSITIVE_INTEGER_EXPRESS.test(number) ||
          DECIMAL_EXPRESS.test(number)
        )
      );
    }
  },
  data() {
    return {
      monthMapper: CN_MONTH_MAPPER
    };
  }
};
